import React from "react";
import {
  PROFANE_AND_PROVISIONAL,
  UPDATED_BY_SYSTEM,
} from "../../../Common/constants";
import { handleKeyboardActivation } from "../../../Common/utils";

const ProfanityAlertIcon = ({ webPurifyStatus, setShowAlertPopup }) => {
  const iconColorClass =
    webPurifyStatus === PROFANE_AND_PROVISIONAL
      ? ""
      : webPurifyStatus === UPDATED_BY_SYSTEM
      ? "si-success"
      : "";

  return (
      <div
        className={`si-league__card-icon si-profanity ${iconColorClass}`}
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation();
          setShowAlertPopup(true);
        }}
        onKeyDown={handleKeyboardActivation((e) => {
          e.stopPropagation();
          setShowAlertPopup(true);
        })}
        aria-label="Show profanity alert"
      >
        <i className="f1i-profanity1"></i>
      </div>
  );
};

export { ProfanityAlertIcon };
